import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/Admin/AdminLayout";
import AdminHeader from "./component/AdminHeader";
import { Multiselect } from "multiselect-react-dropdown";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Quill from "quill";

// ✅ Step 1: Register custom fonts for Quill
const Font = Quill.import("formats/font");
Font.whitelist = [
  "sans-serif",
  "serif",
  "monospace",
  "poppins",

  "montserrat",
  "times-new-roman",
  "georgia",
];
Quill.register(Font, true);

// ✅ Step 2: Add CSS for custom fonts
const customFontStyles = `
  .ql-editor .ql-font-poppins { font-family: 'Poppins', sans-serif; }
  .ql-editor .ql-font-montserrat { font-family: 'Montserrat', sans-serif; }
  .ql-editor .ql-font-times-new-roman { font-family: 'Times New Roman', serif; }
  .ql-editor .ql-font-georgia { font-family: 'Georgia', serif; }
`;

const styleTag = document.createElement("style");
styleTag.innerHTML = customFontStyles;
document.head.appendChild(styleTag);

const modules = {
  toolbar: [
    [{ font: Font.whitelist }, { size: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ header: "1" }, { header: "2" }, "blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    ["link", "image", "video"],
    ["clean"], // remove formatting
  ],
};

const formats = [
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "header",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "indent",
  "align",
  "link",
  "image",
  "video",
];

const AdminEditBlog = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(null);
  const [blog, setBlog] = useState(null);
  const [image, setImage] = useState(null);
  const [allCategories, setAllCategories] = useState([]); // 🏷️ list of all categories
const [allTravelThemes, setAllTravelThemes] = useState([]); // 🌍 all travel themes

  console.log(image);

  const getBlog = async (elm) => {
    await axios
      .post(`api/blog/get-blog`, { id: params.id })
      .then((res) => {
        setBlog(res.data.data);
        setImage(res.data.data.image);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (blog === null) {
      getBlog();
    }
    // eslint-disable-next-line
  }, []);
// 🔹 Fetch all categories
useEffect(() => {
  axios
    .get("/api/category/get-all-category")
    .then((res) => {
      setAllCategories(res.data.data);
    })
    .catch((err) => console.log(err));
}, []);
// 🔹 Fetch all travel themes
useEffect(() => {
  axios
    .get("/api/travel-theme/get-all-travel-themes")
    .then((res) => {
      setAllTravelThemes(res.data.data);
    })
    .catch((err) => console.log(err));
}, []);

  const submit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("id", params.id);
    formData.append("title", blog?.title);
    formData.append("author", blog?.author);
    formData.append("image", image);
    formData.append("description", blog?.description);
    formData.append("categories", JSON.stringify(blog?.categories || [])); // 🏷️ categories array
formData.append("travelTheme", JSON.stringify(blog?.travelTheme || [])); // ✅ added

    formData.append("trending", blog?.trending); // 🔥 trending boolean
    setLoading(true);
    try {
      const res = await axios.post("/api/blog/edit-blog", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.data.success) {
        message.success(res.data.message);
        navigate("/admin-blog");
      } else {
        message.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event) => {
    setBlog({ ...blog, [event.target.name]: event.target.value });
  };

  return (
    <div>
      <Layout>
        <AdminHeader title="Blog" redirect="/admin-dashboard" />
        <div className=" Mon_font px-3 m-0 pb-4">
          <form
            className="row g-3 m-0 px-2 py-3 rounded border border-2"
            style={{ backgroundColor: "#f5f5f5" }}
            onSubmit={submit}
          >
            <div className="col-3 mb-3">
              {image && (
                <img
                  width="100px"
                  className="mb-3"
                  src={`blogImages/${image}`}
                  alt=""
                />
              )}
              <input
                aria-label="Select Image"
                className="form-control"
                type="file"
                accept=".jpg, .jpeg, .png"
                name="image"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>
            <div className="col-12 m-0 ">
              <input
                className="form-control"
                value={blog?.title}
                type="text"
                name="title"
                required
                placeholder="blog title"
                onChange={handleChange}
              />
            </div>
            <div className="col-12 ">
              <input
                className="form-control"
                value={blog?.author}
                type="text"
                name="author"
                required
                placeholder="author name"
                onChange={handleChange}
                maxLength={50}
              />
            </div>{/* ✅ Multiple Category Select */}
<div className="col-4">
  <label>Select Categories</label>
  <Multiselect
    options={allCategories.map((cat) => ({ name: cat.name, id: cat._id }))}
    selectedValues={
      (blog?.categories || []).map((name) => {
        const match = allCategories.find((cat) => cat.name === name);
        return match ? { name: match.name, id: match._id } : null;
      }).filter(Boolean)
    }
    onSelect={(selectedList) =>
      setBlog({
        ...blog,
        categories: selectedList.map((item) => item.name),
      })
    }
    onRemove={(selectedList) =>
      setBlog({
        ...blog,
        categories: selectedList.map((item) => item.name),
      })
    }
    displayValue="name"
    showCheckbox
  />
</div>
{/* ✅ Travel Theme MultiSelect */}
<div className="col-4">
  <label>Select Travel Themes</label>
  <Multiselect
    options={allTravelThemes.map((theme) => ({
      name: theme.name,
      id: theme._id,
    }))}
    selectedValues={
      (blog?.travelTheme || [])
        .map((name) => {
          const match = allTravelThemes.find((theme) => theme.name === name);
          return match ? { name: match.name, id: match._id } : null;
        })
        .filter(Boolean)
    }
    onSelect={(selectedList) =>
      setBlog({
        ...blog,
        travelTheme: selectedList.map((item) => item.name),
      })
    }
    onRemove={(selectedList) =>
      setBlog({
        ...blog,
        travelTheme: selectedList.map((item) => item.name),
      })
    }
    displayValue="name"
    showCheckbox
  />
</div>

{/* ✅ Trending Checkbox */}
<div className="col-2 d-flex align-items-center">
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      name="trending"
      checked={blog?.trending || false}
      onChange={(e) =>
        setBlog({
          ...blog,
          trending: e.target.checked,
        })
      }
    />
    <label className="form-check-label">Trending</label>
  </div>
</div>

          <div className="col-12 mb-3">
  <label><b>Description</b></label>
  <ReactQuill
    theme="snow"
    value={blog?.description || ""}
    onChange={(value) => setBlog({ ...blog, description: value })}
    modules={modules}
    formats={formats}
    placeholder="Write your blog content here..."
    style={{ height: "300px", backgroundColor: "#fff" }}
  />
</div>

            <div className="col-2 d-flex justify-content-center align-items-center">
              <button type="submit" className="btn btn-warning w-100">
                {loading ? "Loading..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </Layout>
    </div>
  );
};

const style = {
  fontSize: "13px",
};

export default AdminEditBlog;
